import Base3DController from './base_3d_controller'

// app/javascript/controllers/metal_controller.js
export default class extends Base3DController {
  static targets = [
    ...Base3DController.targets,
    'printContainer', 'metalPrint', 'frontText', 'printShadow',
    'mountBlock', 'topEdge', 'bottomEdge', 'leftEdge', 'rightEdge',
  ]

  initialize() {
    super.initialize()

    // Metal-specific properties
    this.edgeThickness = 2
    this.floatDistance = 30
    this.currentEdgeStyle = 'white'
    this.printWidth = 200
    this.printHeight = 200
  }

  // Override rotation update for metal print
  updateRotation() {
    if (this.hasPrintContainerTarget) {
      this.printContainerTarget.style.transform = `translate(-50%, -50%) rotateX(${this.rotateXValue}deg) rotateY(${this.rotateYValue}deg)`
    }
  }

  // Override dimension updates for metal print
  updateChildDimensions() {
    this.updatePrintDimensions(this.boxWidthValue, this.boxHeightValue, true)
  }

  // Metal-specific print dimensions update
  updatePrintDimensions(width, height) {
    this.printWidth = (this.initialPrintSize?.width || width)
    this.printHeight = (this.initialPrintSize?.height || height)

    // Set print size
    if (this.hasMetalPrintTarget) {
      this.metalPrintTarget.style.width = `${this.printWidth}px`
      this.metalPrintTarget.style.height = `${this.printHeight}px`
    }

    // Update mount size (typically 50% of the print size)
    if (this.hasMountBlockTarget) {
      const mountWidth = this.printWidth * 0.5
      const mountHeight = this.printHeight * 0.5
      this.mountBlockTarget.style.width = `${mountWidth}px`
      this.mountBlockTarget.style.height = `${mountHeight}px`
      this.mountBlockTarget.style.left = `${(this.printWidth - mountWidth) / 2}px`
      this.mountBlockTarget.style.top = `${(this.printHeight - mountHeight) / 2}px`
    }

    // Update front face and shadow
    if (this.hasFrontFaceTarget) {
      this.frontFaceTarget.style.width = `${this.printWidth}px`
      this.frontFaceTarget.style.height = `${this.printHeight}px`
    }

    if (this.hasPrintShadowTarget) {
      this.printShadowTarget.style.width = `${this.printWidth}px`
      this.printShadowTarget.style.height = `${this.printHeight}px`
    }

    // Update edges
    this.updateEdges()
  }

  updateEdges() {
    if (this.hasTopEdgeTarget) {
      this.topEdgeTarget.style.width = `${this.printWidth}px`
      this.topEdgeTarget.style.left = '0'
    }

    if (this.hasBottomEdgeTarget) {
      this.bottomEdgeTarget.style.width = `${this.printWidth}px`
      this.bottomEdgeTarget.style.transform = `rotateX(-90deg) translateZ(${this.printHeight}px)`
      this.bottomEdgeTarget.style.left = '0'
    }

    if (this.hasLeftEdgeTarget) {
      this.leftEdgeTarget.style.height = `${this.printHeight}px`
      this.leftEdgeTarget.style.top = '0'
    }

    if (this.hasRightEdgeTarget) {
      this.rightEdgeTarget.style.height = `${this.printHeight}px`
      this.rightEdgeTarget.style.transform = `rotateY(90deg) translateZ(${this.printWidth}px)`
      this.rightEdgeTarget.style.top = '0'
    }
  }

  // Override image handling for metal print
  // eslint-disable-next-line no-unused-vars
  handleChildImageLoad(imageUrl, file) {
    // Hide the text when image is loaded
    if (this.hasFrontTextTarget) {
      this.frontTextTarget.style.display = 'none'
    }
  }
}
